import { observer } from 'mobx-react-lite'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import type { ConversationsChartDataStore } from 'pages/analytics/pages/conversations/ui/Chart/store/conversationsChartDataStore'
import { calculateYAxisWidth, getMaxValueFromData } from 'pages/analytics/lib/calculateYAxisWidth'
import styles from 'pages/analytics/pages/conversations/ui/Chart/ui/styles.module.scss'

interface ConversationsBarChartProps {
  chartDataStore: ConversationsChartDataStore
}

export const ConversationsBarChart = observer(({ chartDataStore }: ConversationsBarChartProps) => {
  const { rechartsData } = chartDataStore

  const maxValue = getMaxValueFromData<Record<string, unknown>>(
    rechartsData as unknown as Record<string, unknown>[],
    'new'
  )
  const yAxisWidth = calculateYAxisWidth(maxValue)

  return (
    <div className={styles.chartContainer}>
      <ResponsiveContainer width='100%' height={300}>
        <BarChart data={rechartsData} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
          <CartesianGrid vertical horizontal={false} strokeDasharray={5} />
          <XAxis dataKey='name' interval='preserveStartEnd' minTickGap={1} />
          <YAxis width={yAxisWidth} />
          <Tooltip cursor={false} />
          <Bar
            dataKey='new'
            fill='var(--content-brand-primary)'
            name='New conversations'
            radius={6}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
})
